export default {
  methods: {
    downloadXlsx(data, fileName, type) {
      const blob = new Blob([data], { type })
      const a = window.document.createElement("a")
      a.href = window.URL.createObjectURL(blob, { type })
      a.download = fileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }
}
